var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83541 6.45214C8.04421 5.24334 9.65136 4.57048 11.3608 4.57048C13.0703 4.57048 14.6775 5.24688 15.8863 6.45568C16.6532 7.22265 17.2012 8.14431 17.4995 9.17288H22.3037V2.71574C22.3037 1.20089 21.1328 0.0300293 19.618 0.0300293H3.16084C1.64598 0.0300293 0.36084 1.20089 0.36084 2.71574V9.17288H5.2221C5.5205 8.14431 6.06844 7.21911 6.83541 6.45214ZM20.4762 4.78312C20.4762 5.18707 20.1488 5.51455 19.7448 5.51455H17.5505C17.1466 5.51455 16.8191 5.18712 16.8191 4.78312V2.58884C16.8191 2.1849 17.1465 1.85741 17.5505 1.85741H19.7448C20.1488 1.85741 20.4762 2.18484 20.4762 2.58884V4.78312Z",
    fill: "#014971"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8863 15.5017C14.6775 16.7105 13.0703 17.369 11.3608 17.369C9.65136 17.369 8.04421 16.7141 6.83541 15.5053C5.62884 14.2987 4.96347 12.6571 4.96096 11H0.36084V19.1714C0.36084 20.6863 1.64598 21.9714 3.16084 21.9714H19.618C21.1328 21.9714 22.3037 20.6863 22.3037 19.1714V11H17.7607C17.7583 12.6571 17.0929 14.2951 15.8863 15.5017Z",
    fill: "#014971"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.28e2b0f4024261dd9685e32f2071905c.svg";
export { ForwardRef as ReactComponent };